import { lazyRouteComponent, redirect } from '@tanstack/react-router';
import { BIC_APP_UID, createEwmRoute, MONITORING_APP_UID, ROUTE_TAG_DASHBOARD, BAT_APP_UID, } from '@assetmark/ewm30-routing-shell';
/**
 * @todo: This should be moved out of the routing shell to the monitoringui app.
 * See comment in ewm-routing-shell/src/router/collectEwmAppRoutes.tsx
 */
export const getMonitoringRoutes = (rootRoute, resolver) => {
    /**
     * Possibly in the future we will have a dynamic redirect to the user prefered
     * homepage, but for now we just redirect to the dashboard.
     */
    const indexRoute = createEwmRoute({
        getParentRoute: () => rootRoute,
        path: '/',
        beforeLoad: () => {
            throw redirect({
                to: '/dashboard',
                replace: true,
            });
        },
    });
    const dashboardRoute = createEwmRoute({
        getParentRoute: () => rootRoute,
        path: 'dashboard',
        component: lazyRouteComponent(resolver(MONITORING_APP_UID), 'DashboardLayout'),
        beforeLoad: () => ({
            appUid: MONITORING_APP_UID,
            getTitle: () => 'Home Page',
            getTags: () => [ROUTE_TAG_DASHBOARD],
        }),
    });
    const dashboardIndexRoute = createEwmRoute({
        getParentRoute: () => dashboardRoute,
        path: '/',
        component: lazyRouteComponent(resolver(MONITORING_APP_UID), 'DashboardPage'),
        beforeLoad: () => ({
            appUid: MONITORING_APP_UID,
            getTitle: () => 'Home Page',
            getTags: () => [ROUTE_TAG_DASHBOARD],
        }),
    });
    const bicModalRoute = createEwmRoute({
        getParentRoute: () => dashboardIndexRoute,
        path: 'bic',
        component: lazyRouteComponent(resolver(BIC_APP_UID), 'BicApp'),
        validateSearch: (search) => {
            return {
                sourceProduct: search?.sourceProduct &&
                    typeof (search?.sourceProduct).name ===
                        'string' &&
                    typeof (search?.sourceProduct).id === 'string'
                    ? search.sourceProduct
                    : {},
                advisorIds: Array.isArray(search?.advisorIds) ? search?.advisorIds : [],
                redirect: search?.redirect ? search.redirect : dashboardRoute.fullPath,
            };
        },
        beforeLoad: () => ({
            appUid: MONITORING_APP_UID,
            disableEwmHistory: true,
            getTitle: () => 'Bulk Investment Change – Home Page',
            getTags: () => [ROUTE_TAG_DASHBOARD],
        }),
    });
    const batModalRoute = createEwmRoute({
        getParentRoute: () => dashboardIndexRoute,
        path: 'bat',
        component: lazyRouteComponent(resolver(BAT_APP_UID), 'BatModal'),
        beforeLoad: () => ({
            appUid: MONITORING_APP_UID,
            disableEwmHistory: true,
            getTitle: () => 'Business Assessment Tool – Home Page',
            getTags: () => [ROUTE_TAG_DASHBOARD],
        }),
    });
    return {
        routes: [
            indexRoute,
            dashboardRoute.addChildren([
                dashboardIndexRoute.addChildren([
                    bicModalRoute,
                    ...(String(process.env.MFE_BAT_ENABLED)?.trim() === 'true'
                        ? [batModalRoute]
                        : []),
                ]),
            ]),
        ],
        routeMasks: [],
    };
};
